
import './App.css';

import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@fontsource/roboto/100-italic.css';
import '@fontsource/roboto/300-italic.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/500-italic.css';
import '@fontsource/roboto/700-italic.css';
import '@fontsource/roboto/900-italic.css';

import 'leaflet/dist/leaflet.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router';
import { Component } from "react";
import { Provider } from 'react-redux';
import store from './redux/store';
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import Navigate from './components/Navigate';
import { ENTER_KEY_PRESSED } from './constants';
import Login from './pages/Login';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import device from './device';
import SetPassword from './pages/SetPassword';
import Body from './components/Body';
import VerifyEmail from './pages/VerifyEmail';
import QuickbooksCallback from './pages/QuickbooksCallback';
import Loan from './pages/Loan';

// monkey patching the Component class to add some utility methods
Component.prototype.updateState = function (updates={}) {
	return new Promise(resolve => {
		this.setState(updates, resolve);
	})
}

Component.prototype.overwriteState = function (newState={}) {
	return new Promise(resolve => {
		const oldState = { ...this.state };
		
		for (let key in oldState)
			oldState[key] = undefined;

		const effectiveState = { ...oldState, ...newState }
		this.setState(effectiveState, resolve);

	});
}

// set the window dimensions as css variables
function setDimensions() {
	
	const width = window.innerWidth + 'px';
	const height = window.innerHeight + 'px';

	document.documentElement.style.setProperty('--window-width', width);
	document.documentElement.style.setProperty('--window-height', height);

}

window.addEventListener('resize', setDimensions);
setDimensions();

// listen to enter key press, and dispatch an event
window.addEventListener('keydown', (e) => {
	if (e.key === 'Enter') {
		// no other key is pressed
		if (e.shiftKey) return;
		if (e.ctrlKey) return;
		if (e.altKey) return;
		if (e.metaKey) return;

		// dispatch the event
		const event = new Event(ENTER_KEY_PRESSED);
		window.dispatchEvent(event);
		document.dispatchEvent(event);

	}
});

// initialize the device module
device.init();


// main app component
const theme = createTheme({
	palette: {
		primary: {
			main: '#d97706'
		},
	},
});

function App() {
	return (
		<ThemeProvider theme={theme}>
			<ErrorBoundary>
				<Provider store={store}>
					<Body>
						<Router>
							<Navigate>
								<Routes>
									<Route path="/" element={<Login />} />
									<Route path="/login" element={<Login />} />
									<Route path="/dashboard/*" element={<Dashboard />} />
									<Route path="/set-password/:ref_code" element={<SetPassword />} />
									<Route path='/verify-email/:ref_code' element={<VerifyEmail />} />
									<Route path='/quickbooks/callback' element={<QuickbooksCallback />} />
									<Route path="/loans/:id" element={<Loan />} />
									<Route path="*" element={<NotFound />} />
								</Routes>
							</Navigate>
							<Footer />
						</Router>
					</Body>
				</Provider>
			</ErrorBoundary>
		</ThemeProvider>
  );
}

export default App;